import React from "react";
import "./SupportSection.css";

const SupportSection = () => {
  return (
    <div className="support-section">
      <div className="support-details">
        <h2>Dedicated Support</h2>
        <p>
        At Adcore Consulting, we offer unparalleled support for all your printing needs. Whether it's business cards, branded materials, or   personalized gifts, our team is committed to providing quick and efficient solutions.
        </p>

        <a href='tel: +234-802-387-9629'>
        <button className="purchase-btn">Contact Now</button>
        </a>
      </div>
      <div className="support-image">
          <img src="/images/cu.png" alt="Support" />
      </div>
    </div>
  );
};

export default SupportSection;
